import { render, staticRenderFns } from "./enrol.vue?vue&type=template&id=8c135826&scoped=true&"
import script from "./enrol.vue?vue&type=script&lang=js&"
export * from "./enrol.vue?vue&type=script&lang=js&"
import style0 from "./enrol.vue?vue&type=style&index=0&id=8c135826&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c135826",
  null
  
)

export default component.exports